import request from '@/utils/httpRequest'

// 获取工作台数据
export function workbench (params) {
  return request({
    url: `/workbench`,
    method: 'get',
    params,
    type: 'form'
  })
}
// 获取活跃之星分页列表
export function getPointSumRank (params) {
  return request({
    url: `/point/getPointSumRank`,
    method: 'get',
    params,
    type: 'form'
  })
}
// 获取热门活动排行-分页
export function getHoList (params) {
  return request({
    url: `/activity/hot_list`,
    method: 'get',
    params,
    type: 'form'
  })
}
// 获取活动历史统计柱状图
export function getHistoryStatistics (params) {
  return request({
    url: `/activity/history_statistics`,
    method: 'get',
    params,
    type: 'form'
  })
}


